/* eslint-disable */
export default {
  hide: 'Ausblenden',
  end: 'Beenden',
  keypad: 'Wähltastatur',
} as const;

// @key: @#@"hide"@#@ @source: @#@"Hide"@#@
// @key: @#@"end"@#@ @source: @#@"End"@#@
// @key: @#@"keypad"@#@ @source: @#@"Keypad"@#@
